import React, {useCallback} from 'react';

import {BackButton} from '@buncha/components/composites/Button';
import {Box} from '@buncha/components/core/view';
import {H5Text} from '@buncha/components/core/text';
import Header from '@buncha/components/composites/Header/Header';
import {StyleSheet} from 'react-native';
import {navigation} from '@buncha/config/navigation';

const ShopperTip = () => {
  const handleBack = useCallback(() => {
    navigation.goBack();
  }, []);

  return (
    <Header>
      <BackButton style={styles.backButton} onPress={handleBack} />
      <Box style={styles.container}>
        <H5Text>Please open in Shopper App</H5Text>
      </Box>
    </Header>
  );
};

export default React.memo(ShopperTip);

export const styles = StyleSheet.create({
  backButton: {position: 'absolute', top: 10, left: 10, zIndex: 14},
  container: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
